import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import { Project } from "types";
import { useQueryClient } from "@tanstack/react-query";
import { useUser } from "hooks/useUser";
import { useGetOrg } from "api/organizations/getOrg";
import ManageMembersTable from "./ManageMembersTable";

type EditMemberModalProps = {
  opened: boolean;
  onClose: () => void;
  project: Project;
  orgId: string | undefined;
  projects: Project[];
};

function EditMemberModal({
  opened,
  onClose,
  project,
  orgId,
  projects,
}: EditMemberModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="auto"
      overflow="inside"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={`Edit Members of ${project?.name}`}
        onClose={onClose}
        ariaLabel="Close edit members modal"
      />

      <ManageMembersTable
        projects={projects}
        project={project}
        orgId={orgId}
        onClose={onClose}
      />
    </Modal>
  );
}

export default EditMemberModal;
